import store from 'store';
class Setting {
    constructor() {
        this.store = store.namespace('setting');
    }
    get dark() {
        return this.store.get('dark') || false;
    }
    setFirstIn() {
        this.store.set('first-in', true);
    }
    getFirstIn() {
        return this.store.get('first-in');
    }
    setDark(mode) {
        this.store.set('dark', mode);
    }
    setContactData(options) {
        this.store.set('contact', options);
    }
    getContactData() {
        return (this.store.get('contact') || { person: '' });
    }
}
export const setting = new Setting();
